import classNames from 'classnames';
import WidgetDropTarget from 'components/ui-blocks/widget/WidgetDropTarget';
import React from 'react';
import type { WidgetReference } from 'redux/modules/superreports.types';
import { createWidgetElementId } from 'utils/superreports';
import styles from './WidgetList.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  draggedReference?: WidgetReference | null;
  half?: boolean;
  single?: boolean;
  reference: WidgetReference;
  sequence: number;
}

export const WidgetListItem = React.forwardRef<HTMLLIElement, Props>(
  ({ children, reference, half, single, className, sequence, draggedReference, ...rest }, ref) => {
    const showDropTargets = draggedReference && draggedReference !== reference;
    const showHorizontalDropTargets = showDropTargets && !half;
    const showVerticalDropTargets = showDropTargets && half;
    return (
      <li
        className={classNames(styles.widgetBlock, {
          [styles.widgetHalfBlock]: half,
          [styles.single]: single,
          [styles.dragging]: draggedReference === reference,
          className,
        })}
        id={createWidgetElementId(reference)}
        ref={ref}
        {...rest}
      >
        {children}
        {showHorizontalDropTargets && <WidgetDropTarget targetSequence={sequence} position="top" />}
        {showHorizontalDropTargets && (
          <WidgetDropTarget targetSequence={sequence + 1} position="bottom" />
        )}
        {showVerticalDropTargets && <WidgetDropTarget targetSequence={sequence} position="left" />}
        {showVerticalDropTargets && (
          <WidgetDropTarget targetSequence={sequence + 1} position="right" />
        )}
      </li>
    );
  }
);

WidgetListItem.displayName = 'WidgetListItem';
